import { isEqual } from 'lodash-es';
import { _preProcessWatchers } from './computed';

// for async case , use computed instead, current version support async computed properties for updatingElement

export default function autoRun(watchers, { showLoader = true } = {}) {
  watchers = _preProcessWatchers(watchers);

  return function decorator(target, key, descriptor) {
    if (descriptor.value && typeof descriptor.value === 'function' && target.updated) {
      const originFn = descriptor.value;

      const originUpdated = target.updated;

      // TODO wrapper too much level ?
      target.updated = function updated(changedProperties) {
        const cacheParamsKey = `__cached_params_${key}`;

        setTimeout(() => {
          try {
            const values = watchers.map(w => w(this));
            if (
              !this[cacheParamsKey] ||
              !values.every((v, i) => isEqual(v, this[cacheParamsKey][i]))
            ) {
              this[cacheParamsKey] = values;
              const re = originFn.apply(this, values); // exec function
              if (showLoader && re && re.then && this.promiseLoader) {
                this.promiseLoader(re);
              }
            }
          } catch (e) {
            console.error(e);
          }
        });
        return originUpdated.call(this, changedProperties);
      };
    }
    return descriptor;
  };
}
